<div class="flex flex-col justify-center items-center mt-16">
  <mat-spinner color="primary" diameter="30"></mat-spinner>
</div>
